// Focuses the top error field on screen
const focusToTopErrorFieldOnScreen = ()=>{
    if (typeof window !== 'undefined') {
        focusToTopErrorFieldOf(window.document);
    }
};
// Focuses the top error field within a container
const focusToTopErrorFieldOf = (container)=>{
    const topErrorField = container.querySelector('input[aria-invalid="true"], select[aria-invalid="true"], button[aria-invalid="true"]');
    topErrorField === null || topErrorField === void 0 ? void 0 : topErrorField.focus();
};

export { focusToTopErrorFieldOf, focusToTopErrorFieldOnScreen };
//# sourceMappingURL=focus-to-top-error-field.js.map
